const actions = {
  SET_STATE: 'user/SET_STATE',
  LOGIN: 'user/LOGIN',
  RESET_PASSWORD: 'user/RESET_PASSWORD',
  FORGOT_PASSWORD: 'user/FORGOT_PASSWORD',
  REGISTER: 'user/REGISTER',
  LOAD_CURRENT_ACCOUNT: 'user/LOAD_CURRENT_ACCOUNT',
  LOGOUT: 'user/LOGOUT'
}

export default actions
